/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AskResetPasswordDto } from '../models/ask-reset-password-dto';
import { AuthenticateDto } from '../models/authenticate-dto';
import { AuthenticateFromCodeDto } from '../models/authenticate-from-code-dto';
import { AuthenticateFromMaslDto } from '../models/authenticate-from-masl-dto';
import { ChangePasswordDto } from '../models/change-password-dto';
import { SetPasswordWithTokenRequestDto } from '../models/set-password-with-token-request-dto';
import { TokenDto } from '../models/token-dto';


/**
 * Fonctions d'authentification
 */
@Injectable({
  providedIn: 'root',
})
export class AuthentificationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation authenticationAuthenticateWithForm
   */
  static readonly AuthenticationAuthenticateWithFormPath = '/api/authentication/token-with-form';

  /**
   * Authentifie un utilisateur avec un formulaire (utilisé par la page web de Swagger)).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAuthenticateWithForm()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  authenticationAuthenticateWithForm$Response(params?: {
    body?: {
'grant_type'?: string | null;
'username'?: string | null;
'password'?: string | null;
'client_id'?: string | null;
'client_secret'?: string | null;
}
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAuthenticateWithFormPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * Authentifie un utilisateur avec un formulaire (utilisé par la page web de Swagger)).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAuthenticateWithForm$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  authenticationAuthenticateWithForm(params?: {
    body?: {
'grant_type'?: string | null;
'username'?: string | null;
'password'?: string | null;
'client_id'?: string | null;
'client_secret'?: string | null;
}
  }): Observable<TokenDto> {

    return this.authenticationAuthenticateWithForm$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authenticationAuthenticateWithJson
   */
  static readonly AuthenticationAuthenticateWithJsonPath = '/api/authentication/token';

  /**
   * Authentifie un utilisateur avec des données JSON (utilisé par la plupart des clients).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAuthenticateWithJson()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticateWithJson$Response(params: {

    /**
     * Données d'authentification
     */
    body: AuthenticateDto
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAuthenticateWithJsonPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * Authentifie un utilisateur avec des données JSON (utilisé par la plupart des clients).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAuthenticateWithJson$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticateWithJson(params: {

    /**
     * Données d'authentification
     */
    body: AuthenticateDto
  }): Observable<TokenDto> {

    return this.authenticationAuthenticateWithJson$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authenticationAuthenticateWithCode
   */
  static readonly AuthenticationAuthenticateWithCodePath = '/api/authentication/token-with-code';

  /**
   * Authentifie un utilisateur avec un code de connexion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAuthenticateWithCode()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticateWithCode$Response(params: {

    /**
     * Données d'authentification
     */
    body: AuthenticateFromCodeDto
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAuthenticateWithCodePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * Authentifie un utilisateur avec un code de connexion.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAuthenticateWithCode$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticateWithCode(params: {

    /**
     * Données d'authentification
     */
    body: AuthenticateFromCodeDto
  }): Observable<TokenDto> {

    return this.authenticationAuthenticateWithCode$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authenticationAuthenticatePersonnePhysique
   */
  static readonly AuthenticationAuthenticatePersonnePhysiquePath = '/api/authentication/token-pp';

  /**
   * Authentifie une personne physique avec un identifiant ou une adresse e-mail et un mot de passe.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAuthenticatePersonnePhysique()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticatePersonnePhysique$Response(params: {

    /**
     * Données d'authentification
     */
    body: AuthenticateDto
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAuthenticatePersonnePhysiquePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * Authentifie une personne physique avec un identifiant ou une adresse e-mail et un mot de passe.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAuthenticatePersonnePhysique$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticatePersonnePhysique(params: {

    /**
     * Données d'authentification
     */
    body: AuthenticateDto
  }): Observable<TokenDto> {

    return this.authenticationAuthenticatePersonnePhysique$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authenticationGetLoginCode
   */
  static readonly AuthenticationGetLoginCodePath = '/api/authentication/generate-code';

  /**
   * Génère un nouveau code de connexion pour l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationGetLoginCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationGetLoginCode$Response(params?: {

    /**
     * Identifiant de l&#x27;utilisateur
     */
    userId?: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationGetLoginCodePath, 'post');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Génère un nouveau code de connexion pour l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationGetLoginCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authenticationGetLoginCode(params?: {

    /**
     * Identifiant de l&#x27;utilisateur
     */
    userId?: number;
  }): Observable<string> {

    return this.authenticationGetLoginCode$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation authenticationAuthenticateWithMsal
   */
  static readonly AuthenticationAuthenticateWithMsalPath = '/api/authentication/azure-msal';

  /**
   * Authentifie un utilisateur après validation dans le portail Azure.
   * Si l'utilisateur n'existe pas, il est automatiquement créé.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAuthenticateWithMsal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticateWithMsal$Response(params: {

    /**
     * Données d'identification
     */
    body: AuthenticateFromMaslDto
  }): Observable<StrictHttpResponse<TokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAuthenticateWithMsalPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TokenDto>;
      })
    );
  }

  /**
   * Authentifie un utilisateur après validation dans le portail Azure.
   * Si l'utilisateur n'existe pas, il est automatiquement créé.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAuthenticateWithMsal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAuthenticateWithMsal(params: {

    /**
     * Données d'identification
     */
    body: AuthenticateFromMaslDto
  }): Observable<TokenDto> {

    return this.authenticationAuthenticateWithMsal$Response(params).pipe(
      map((r: StrictHttpResponse<TokenDto>) => r.body as TokenDto)
    );
  }

  /**
   * Path part for operation authenticationAskPasswordReset
   */
  static readonly AuthenticationAskPasswordResetPath = '/api/authentication/reset-password';

  /**
   * Crée une demande de réinitialisation de mot de passe.
   * On renvoie OK dans tous les cas (même si l'adresse n'est pas trouvée).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAskPasswordReset()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAskPasswordReset$Response(params: {

    /**
     * Adresse e-mail pour laquelle on fait la demande de réinitialisation du mot de passe
     */
    body: AskResetPasswordDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAskPasswordResetPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée une demande de réinitialisation de mot de passe.
   * On renvoie OK dans tous les cas (même si l'adresse n'est pas trouvée).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAskPasswordReset$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAskPasswordReset(params: {

    /**
     * Adresse e-mail pour laquelle on fait la demande de réinitialisation du mot de passe
     */
    body: AskResetPasswordDto
  }): Observable<void> {

    return this.authenticationAskPasswordReset$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation authenticationAskPersonnePhysiquePasswordReset
   */
  static readonly AuthenticationAskPersonnePhysiquePasswordResetPath = '/api/authentication/reset-password-pp';

  /**
   * Crée une demande de réinitialisation de mot de passe pour une personne physique.
   * On renvoie OK dans tous les cas (même si l'adresse n'est pas trouvée).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAskPersonnePhysiquePasswordReset()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAskPersonnePhysiquePasswordReset$Response(params: {

    /**
     * Adresse e-mail pour laquelle on fait la demande de réinitialisation du mot de passe
     */
    body: AskResetPasswordDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAskPersonnePhysiquePasswordResetPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée une demande de réinitialisation de mot de passe pour une personne physique.
   * On renvoie OK dans tous les cas (même si l'adresse n'est pas trouvée).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAskPersonnePhysiquePasswordReset$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAskPersonnePhysiquePasswordReset(params: {

    /**
     * Adresse e-mail pour laquelle on fait la demande de réinitialisation du mot de passe
     */
    body: AskResetPasswordDto
  }): Observable<void> {

    return this.authenticationAskPersonnePhysiquePasswordReset$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation authenticationAskPasswordSet
   */
  static readonly AuthenticationAskPasswordSetPath = '/api/authentication/set-password';

  /**
   * Crée une demande d'initialisation de mot de passe.
   * On renvoie OK dans tous les cas (même si l'adresse n'est pas trouvée).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationAskPasswordSet()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAskPasswordSet$Response(params: {

    /**
     * Adresse e-mail pour laquelle on fait la demande d'initialisation du mot de passe
     */
    body: AskResetPasswordDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationAskPasswordSetPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée une demande d'initialisation de mot de passe.
   * On renvoie OK dans tous les cas (même si l'adresse n'est pas trouvée).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationAskPasswordSet$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationAskPasswordSet(params: {

    /**
     * Adresse e-mail pour laquelle on fait la demande d'initialisation du mot de passe
     */
    body: AskResetPasswordDto
  }): Observable<void> {

    return this.authenticationAskPasswordSet$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation authenticationSetPasswordWithToken
   */
  static readonly AuthenticationSetPasswordWithTokenPath = '/api/authentication/set-password-with-token';

  /**
   * Réinitialise le mot de passe au moyen d'un token de réinitialisation de mot de passe (obtenu en appelant /reset-password).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationSetPasswordWithToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationSetPasswordWithToken$Response(params: {

    /**
     * Informations de réinitialisation de mot de passe
     */
    body: SetPasswordWithTokenRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationSetPasswordWithTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Réinitialise le mot de passe au moyen d'un token de réinitialisation de mot de passe (obtenu en appelant /reset-password).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationSetPasswordWithToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationSetPasswordWithToken(params: {

    /**
     * Informations de réinitialisation de mot de passe
     */
    body: SetPasswordWithTokenRequestDto
  }): Observable<void> {

    return this.authenticationSetPasswordWithToken$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation authenticationSetPersonnePhysiquePasswordWithToken
   */
  static readonly AuthenticationSetPersonnePhysiquePasswordWithTokenPath = '/api/authentication/set-password-with-token-pp';

  /**
   * Réinitialise le mot de passe d'une personne physique au moyen d'un token de réinitialisation de mot de passe (obtenu en appelant /reset-password-pp).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationSetPersonnePhysiquePasswordWithToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationSetPersonnePhysiquePasswordWithToken$Response(params: {

    /**
     * Informations de réinitialisation de mot de passe
     */
    body: SetPasswordWithTokenRequestDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationSetPersonnePhysiquePasswordWithTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Réinitialise le mot de passe d'une personne physique au moyen d'un token de réinitialisation de mot de passe (obtenu en appelant /reset-password-pp).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationSetPersonnePhysiquePasswordWithToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationSetPersonnePhysiquePasswordWithToken(params: {

    /**
     * Informations de réinitialisation de mot de passe
     */
    body: SetPasswordWithTokenRequestDto
  }): Observable<void> {

    return this.authenticationSetPersonnePhysiquePasswordWithToken$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation authenticationChangePassword
   */
  static readonly AuthenticationChangePasswordPath = '/api/authentication/change-password';

  /**
   * Modifie le mot de passe de l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationChangePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationChangePassword$Response(params: {

    /**
     * Identifiant de l&#x27;utilisateur
     */
    utilisateurId?: number;

    /**
     * Informations de changement de mot de passe
     */
    body: ChangePasswordDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationChangePasswordPath, 'post');
    if (params) {
      rb.query('utilisateurId', params.utilisateurId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Modifie le mot de passe de l'utilisateur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationChangePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationChangePassword(params: {

    /**
     * Identifiant de l&#x27;utilisateur
     */
    utilisateurId?: number;

    /**
     * Informations de changement de mot de passe
     */
    body: ChangePasswordDto
  }): Observable<void> {

    return this.authenticationChangePassword$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation authenticationChangePersonnePhysiquePassword
   */
  static readonly AuthenticationChangePersonnePhysiquePasswordPath = '/api/authentication/change-password-pp';

  /**
   * Modifie le mot de passe de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authenticationChangePersonnePhysiquePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationChangePersonnePhysiquePassword$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    login?: string;

    /**
     * Informations de changement de mot de passe
     */
    body: ChangePasswordDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AuthentificationService.AuthenticationChangePersonnePhysiquePasswordPath, 'post');
    if (params) {
      rb.query('login', params.login, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Modifie le mot de passe de la personne physique spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `authenticationChangePersonnePhysiquePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authenticationChangePersonnePhysiquePassword(params: {

    /**
     * Identifiant de la personne physique
     */
    login?: string;

    /**
     * Informations de changement de mot de passe
     */
    body: ChangePasswordDto
  }): Observable<void> {

    return this.authenticationChangePersonnePhysiquePassword$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
